import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { SERVER_API_URL } from '../app.constants';
import { ISystemConfigModel } from './model/system-config.model';

@Injectable({ providedIn: 'root' })
export class SystemService {
  private systemUrl = SERVER_API_URL + 'api/system/';
  public systemState = new BehaviorSubject<ISystemConfigModel | null>(null);
  private loadInFlight = false;

  constructor(private http: HttpClient) {}

  getSystemState(): Observable<ISystemConfigModel> {
    // Lazily kick off load() on first subscription if it hasn't been called yet.
    // Necessary because in MSAL mode App.ngOnInit() defers load() to
    // AppMainComponent.ngOnInit(), which fires AFTER child route guards run —
    // route guards (e.g. systemModuleAccessGuard) would otherwise deadlock on a
    // hard refresh of routes like /survey, /survey-analytics, /my-survey, /my-confirmations.
    if (this.systemState.value === null && !this.loadInFlight) {
      this.load();
    }
    return this.systemState.asObservable().pipe(
      filter((state): state is ISystemConfigModel => state !== null)
    );
  }

  load(): void {
    this.loadInFlight = true;
    this.http.get<ISystemConfigModel>(`${this.systemUrl}config`).subscribe({
      next: config => {
        this.systemState.next(config);
        this.loadInFlight = false;
      },
      error: () => {
        this.loadInFlight = false;
      },
    });
  }

  saveDefaultNodeState(state: boolean): Observable<any> {
    return this.http.get(`${this.systemUrl}config/${state}`, { observe: 'response' });
  }
}
